import Cookies from "js-cookies"
export default () => {
  (function($) {
    $(document).ready(function() {
      if(location.href.indexOf("/individual") > -1) {
        console.log(Cookies.getItem('disclaimer_agree'))
        if (!(Cookies.getItem('disclaimer_agree') == 'Y')) {
          $('.modal.disclaimer').modal('show')
        }
      } else if(location.href.indexOf("/institutional") > -1) {
        console.log(Cookies.getItem('InstitutionalBusinessDisclaimer'))
        if (!(Cookies.getItem('InstitutionalBusinessDisclaimer') == 'Y')) {
          $('.modal.disclaimer').modal('show')
        }
      }
      $('.disclaimer__body').scroll(function() {
        if ($('.disclaimer__body').scrollTop() >= $('.disclaimer__text').height() - $('.disclaimer__body').outerHeight()) {
          $('.disclaimer__button--submit').attr({
            'aria-disabled': false,
            'data-dismiss': 'modal'
          })
        }
      })
      $('.disclaimer__button--outline').on('click', function() {
        if ($(this).data('disagreelink')) {
          location.href = $(this).data('disagreelink')
        }
      })
      $('.disclaimer__button--submit').on('click', function() {
        if ($(this).is('[aria-disabled="false"]')) {
          var cookieItem = $(this).data('cookie')
          Cookies.setItem(cookieItem, 'Y', null, '/');
        } else {
          $('.disclaimer__msg').show()
          $('.disclaimer__body').css('border-color', 'red')
        }
      })
    })
  })(window.hsvmJQuery)
}